import React from "react";
import {NavLink} from "react-router-dom";
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    useColorModeValue,
    useToast,
} from "@chakra-ui/react";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {RiEyeCloseLine} from "react-icons/ri";
import {useDispatch} from "react-redux";
import {useUserLoginMutation} from "../store/userApi/userApiSlice.ts";
import {setCredentials} from "../store/slices/userSlice.ts";
import Footer from "../components/footer/FooterAuth";
import FixedPlugin from "../components/fixedPlugin/FixedPlugin";

function Login() {
    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
    const [show, setShow] = React.useState(false);
    const handleClick = () => setShow(!show);
    const [login] = useUserLoginMutation();
    const dispatch = useDispatch();
    const toast = useToast();

    async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const username = formData.get("username");
        const password = formData.get("password");

        try {
            const response: any = await login({username, password});
            if (response?.data) {
                const userDetails = {
                    firstName: response.data.first_name,
                    lastName: response.data.last_name,
                    user_id: response.data.user_id,
                    email: response.data.email,
                    isSuperuser: response.data.is_superuser,
                    username: response.data.username,
                };
                const accessToken: string = response.data.access_token;
                console.log("user details are :: ", userDetails, " access token are ::: ", accessToken);
                dispatch(setCredentials({user: userDetails, token: accessToken}));
                toast({
                    title: "Login successful",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
            } else {
                throw new Error("Invalid credentials");
            }
        } catch (error) {
            toast({
                title: "Login failed",
                description: "Invalid username or password",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }

    return (
        <Flex position='relative' h='max-content'>
            <Flex
                h={{
                    sm: "initial",
                    md: "unset",
                    lg: "100vh",
                    xl: "97vh",
                }}
                w='100%'
                maxW={{md: "66%", lg: "1313px"}}
                mx='auto'
                pt={{sm: "50px", md: "0px"}}
                px={{lg: "30px", xl: "0px"}}
                ps={{xl: "70px"}}
                justifyContent='start'
                direction='column'>
                <NavLink
                    to='/admin'
                    style={() => ({
                        width: "fit-content",
                        marginTop: "40px",
                    })}>
                </NavLink>
                <Flex
                    maxW={{base: "100%", md: "max-content"}}
                    w="100%"
                    mx={{base: "auto", lg: "0px"}}
                    me="auto"
                    h="100%"
                    alignItems="start"
                    justifyContent="center"
                    px={{base: "25px", md: "0px"}}
                    mt={{base: "40px", md: "14vh"}}
                    flexDirection="column"
                >
                    <Box me="auto">
                        <Heading color={textColor} fontSize="36px" mb="10px">
                            Sign In
                        </Heading>
                        <Text mb="36px" ms="4px" color={textColorSecondary} fontWeight="400" fontSize="md">
                            Enter your username and password to sign in!
                        </Text>
                    </Box>

                    <form onSubmit={handleSubmit}>
                        <Flex
                            zIndex="2"
                            direction="column"
                            w={{base: "100%", md: "420px"}}
                            background="transparent"
                            borderRadius="15px"
                            mb={{base: "20px", md: "auto"}}
                        >
                            {/*<Button*/}
                            {/*    fontSize="sm"*/}
                            {/*    mb="26px"*/}
                            {/*    py="15px"*/}
                            {/*    h="50px"*/}
                            {/*    borderRadius="16px"*/}
                            {/*    bg={googleBg}*/}
                            {/*    color={googleText}*/}
                            {/*    fontWeight="500"*/}
                            {/*    _hover={googleHover}*/}
                            {/*    _active={googleActive}*/}
                            {/*>*/}
                            {/*    <Icon as={FcGoogle} w="20px" h="20px" me="10px" />*/}
                            {/*    Sign in with Google*/}
                            {/*</Button>*/}

                            {/*<Flex align="center" mb="25px">*/}
                            {/*    <HSeparator />*/}
                            {/*    <Text color="gray.400" mx="14px">*/}
                            {/*        or*/}
                            {/*    </Text>*/}
                            {/*    <HSeparator />*/}
                            {/*</Flex>*/}

                            <FormControl isRequired>
                                <FormLabel fontSize="sm" fontWeight="500" color={textColor} mb="8px">
                                    Username
                                </FormLabel>
                                <Input
                                    name="username"
                                    type="text"
                                    placeholder="your username"
                                    mb="24px"
                                    fontSize="sm"
                                    size="lg"
                                    variant="auth"
                                />
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel fontSize="sm" fontWeight="500" color={textColor}>
                                    Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        name="password"
                                        type={show ? "text" : "password"}
                                        placeholder="your password"
                                        mb="24px"
                                        size="lg"
                                        fontSize="sm"
                                        variant="auth"
                                    />
                                    <InputRightElement display="flex" alignItems="center" mt="4px">
                                        <Icon
                                            color={textColorSecondary}
                                            _hover={{cursor: "pointer"}}
                                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                            onClick={handleClick}
                                        />
                                    </InputRightElement>
                                </InputGroup>
                            </FormControl>

                            {/*<Flex justifyContent="space-between" align="center" mb="24px">*/}
                            {/*    <FormControl display="flex" alignItems="center">*/}
                            {/*        <Checkbox id="remember-login" colorScheme="brandScheme" me="10px" />*/}
                            {/*        <FormLabel htmlFor="remember-login" mb="0" fontWeight="normal" color={textColor} fontSize="sm">*/}
                            {/*            Keep me logged in*/}
                            {/*        </FormLabel>*/}
                            {/*    </FormControl>*/}
                            {/*    <NavLink to="/auth/forgot-password">*/}
                            {/*        <Text color={textColorBrand} fontSize="sm" fontWeight="500">*/}
                            {/*            Forgot password?*/}
                            {/*        </Text>*/}
                            {/*    </NavLink>*/}
                            {/*</Flex>*/}

                            <Button
                                type="submit"
                                fontSize="sm"
                                variant="brand"
                                fontWeight="500"
                                w="100%"
                                h="50"
                                mb="24px"
                            >
                                Sign In
                            </Button>

                            {/*<Flex flexDirection="column" justifyContent="center" alignItems="start">*/}
                            {/*    <Text color={textColorDetails} fontWeight="400" fontSize="14px">*/}
                            {/*        Not registered yet?*/}
                            {/*        <NavLink to="/auth/sign-up">*/}
                            {/*            <Text color={textColorBrand} as="span" ms="5px" fontWeight="500">*/}
                            {/*                Create an Account*/}
                            {/*            </Text>*/}
                            {/*        </NavLink>*/}
                            {/*    </Text>*/}
                            {/*</Flex>*/}
                        </Flex>
                    </form>
                </Flex>
                <Box
                    display={{base: "none", md: "block"}}
                    h='100%'
                    minH='100vh'
                    w={{lg: "50vw", "2xl": "44vw"}}
                    position='absolute'
                    right='0px'
                    borderBottomLeftRadius='180px'
                    overflow='hidden'
                >
                    {/*<Image*/}
                    {/*    src={Banner}*/}
                    {/*    alt="Login Illustration"*/}
                    {/*    objectFit="cover"*/}
                    {/*    w="100%"*/}
                    {/*    h="100%"*/}
                    {/*/>*/}
                </Box>
                <Footer/>
            </Flex>
            <FixedPlugin/>
        </Flex>
    );
}

export default Login;
